// extracted by mini-css-extract-plugin
module.exports = {"authorImage":"ArticleAuthor_authorImage__Tuj_8","authorImageContainer":"ArticleAuthor_authorImageContainer__MlaUm"};